import Vue from 'vue'
import Vuex from 'vuex'

import categories from '@/store/categories'
import products from '@/store/products'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    categories,
    products,
  },
})



// WEBPACK FOOTER //
// ./src/store/index.js